// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable react/sort-comp, class-methods-use-this, react/destructuring-assignment, jsx-a11y/label-has-for, */
import * as React from "react"
import classnames from "classnames"
import * as R from "ramda"

import Translate from "../../../../app/scripts/components/Translate"
import { omitRedundantFields } from "../../consts/form"
import { cuckooEvents } from "../../consts/enums"
import cuckoo from "../../services/cuckoo/cuckoo"
import fieldValidation from "../../utils/fieldValidation"

type Props = {
  value: string | null | undefined
  onChange: (arg1: string) => void
  icon?: React.ReactNode
  label?: React.ReactNode
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error?: string | any
  required?: boolean
  format?: (arg1: string) => string
  normalize?: (arg1: string) => string
  twoLines?: boolean
  touched?: boolean
  active?: boolean
  dataTest?: string
  withoutColon?: boolean // hack for translations which don't need colon after text,
  disableRecording?: boolean
  type?: "text" | "email" | "number" | "password" | "tel" | "date"
  disabled?: boolean
  autoComplete?: string
}

type State = {
  isFocused: boolean
}

export default class NewTextField extends React.PureComponent<Props, State> {
  static defaultProps = {
    format: (value: string) => value,
    type: "text",
  }

  state = {
    isFocused: false,
  }

  handleBlur = () => {
    this.setState({
      isFocused: false,
    })
  }

  handleFocus = () => {
    this.setState({
      isFocused: true,
    })
  }

  handleChange = (event: Event) => {
    const { normalize, onChange, type: inputType } = this.props
    const { target } = event
    if (target instanceof HTMLInputElement) {
      const normalizedValue = normalize ? normalize(target.value) : target.value
      onChange(normalizedValue)

      let currentSelectionIndex = target.selectionStart
      // @ts-expect-error: Flow to TS migration.
      const previousValue = normalizedValue[currentSelectionIndex - 1]
      // @ts-expect-error: Flow to TS migration.
      const currentValue = normalizedValue[currentSelectionIndex]

      if (previousValue === " " || currentValue === " ") {
        // @ts-expect-error: Flow to TS migration.
        currentSelectionIndex += 1
      }

      const wasNormalized = target.value !== normalizedValue

      // There is a bug in some versions of mobile Chrome: When the normalized value is longer
      // than the typed text (eg. creditCardNormalizer transforms "12345" to "1234 5"), in some
      // browsers the cursor isn't placed to the end of the input, but stays on its original
      // position (just before "5" in the card example).
      //
      // This fix has to be in the setTimeout so it is executed after the event that moves the
      // cursor to the wrong position.
      //
      // We don't want to use this if the value was not normalized
      // it makes a weird behaviour if we just add a space inside the value
      if (inputType === "text" && normalize && wasNormalized) {
        window.setTimeout(() => {
          target.setSelectionRange(currentSelectionIndex, currentSelectionIndex)
        }, 0)
      }
    }
  }

  // FIXME: sort methods in React components according to conventions

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderError(error: string | any) {
    const props = {
      className: "spField-note spTypo-note",
      ...(typeof error === "string" ? { tKey: error } : error),
    } as const

    return (
      error && (
        <div className="spField-error">
          <Translate {...props} />
        </div>
      )
    )
  }

  renderLabel(
    label?: React.ReactNode | null,
    twoLines?: boolean | null,
    required?: boolean | null,
    withoutColon?: boolean | null,
  ) {
    return (
      <div className="spField-label">
        {label}
        {twoLines || withoutColon ? "" : ":"}
        {required && twoLines ? "*" : ""}
      </div>
    )
  }

  handleSelectingCorrected = () => {
    const { value } = this.props
    if (value) {
      const corrected = value

      this.props.onChange(corrected || "")

      cuckoo.track(cuckooEvents.MANAGE_FORM_INPUT_CORRECTED, {
        from: value,
        to: corrected,
      })
    }
  }

  render() {
    const {
      value,
      format,
      active,
      icon,
      label,
      error,
      touched,
      twoLines,
      required,
      dataTest,
      withoutColon,
      disableRecording,
      disabled,
      type,
    } = this.props

    const validation = fieldValidation({
      error: Boolean(error) && touched,
      ok: !error && touched,
    })

    const classes = classnames("NewTextField", "spField", validation.className, {
      _hasLabel: label,
      _oneLine: !twoLines,
      _twoLines: twoLines,
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      _active: active || this.state.isFocused,
      _disabled: disabled,
    })

    // Warning: `value` prop on `input` should not be null.
    // Consider using the empty string to clear the component or `undefined` for uncontrolled components.
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    const safeValue = value || ""

    return (
      <div className={classes} data-test={dataTest && `${dataTest}-wrapper`}>
        {twoLines && validation.icon}
        <label>
          <div className="spField-label-wrap">
            {icon && <div className="spField-icon">{icon}</div>}
            {label && this.renderLabel(label, twoLines, required, withoutColon)}
          </div>

          {error && touched && this.renderError(error)}

          <div className="spField-input">
            <input
              onBlur={this.handleBlur}
              onFocus={this.handleFocus}
              className={classnames({
                "spField-input-raw": true,
                "fs-hide": disableRecording,
              })}
              data-test={dataTest}
              data-sl={disableRecording ? "mask" : "unmask"}
              {...(disableRecording ? { "data-recording-ignore": "events" } : {})}
              {...R.omit(
                ["twoLines", "normalize", "disableRecording", "dataTest"],
                omitRedundantFields(this.props),
              )}
              value={!active && value && format ? format(safeValue) : safeValue}
              // @ts-expect-error: Flow to TS migration.
              onChange={this.handleChange}
              disabled={disabled}
              type={type}
            />
          </div>
        </label>
      </div>
    )
  }
}
